var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('canvas',{ref:"crp",attrs:{"width":"1006","height":"674"}})])}
var staticRenderFns = []

export { render, staticRenderFns }